
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      role: 'Local Business Owner',
      rating: 5,
      text: 'Seneca Tire Shop has been servicing my fleet of delivery vehicles for years. Their tire selection is excellent, prices are fair, and the service is always fast and professional. Highly recommend for both new and used tires!',
      image: 'https://public.readdy.ai/ai/img_res/f9ebee0d4ec9cfc39fef769afa9a4f57.jpg'
    },
    {
      name: 'Sarah Thompson',
      role: 'Daily Commuter',
      rating: 5,
      text: 'I needed new tires urgently and Seneca Tire Shop came through! They had the perfect set in stock, installed them same day, and the price was better than anywhere else I checked. The staff was knowledgeable and friendly.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20friendly%20young%20Caucasian%20female%20professional%20in%20business%20casual%20attire%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20high%20quality%20corporate%20portrait&width=200&height=200&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'James Chen',
      role: 'Car Enthusiast',
      rating: 5,
      text: 'As someone who cares about performance, I trust Seneca Tire Shop for all my tire needs. They carry premium brands and their technicians really know their stuff. The wheel alignment service is top-notch too!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20confident%20young%20Asian%20male%20professional%20in%20casual%20shirt%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20high%20quality%20corporate%20portrait&width=200&height=200&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Emily Martinez',
      role: 'Budget-Conscious Shopper',
      rating: 5,
      text: 'The used tire selection at Seneca Tire Shop is amazing! I found a great set with plenty of tread left at a fraction of the cost of new ones. They were honest about the condition and the installation was perfect.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20cheerful%20young%20Hispanic%20female%20professional%20in%20casual%20attire%2C%20bright%20smile%2C%20clean%20white%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20high%20quality%20corporate%20portrait&width=200&height=200&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'David Wilson',
      role: 'Truck Owner',
      rating: 5,
      text: 'I have a heavy-duty pickup and finding the right tires can be challenging. Seneca Tire Shop always has what I need in stock and their prices on truck tires are the best around. Great service every time!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20mature%20Caucasian%20male%20professional%20with%20short%20hair%20in%20casual%20shirt%2C%20confident%20smile%2C%20clean%20white%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20high%20quality%20corporate%20portrait&width=200&height=200&seq=testimonial-005&orientation=squarish'
    },
    {
      name: 'Lisa Anderson',
      role: 'Family Driver',
      rating: 5,
      text: 'Safety is my top priority with kids in the car. Seneca Tire Shop helped me choose the perfect all-season tires for my SUV and explained everything clearly. The free tire inspection service is a great bonus!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20friendly%20middle-aged%20Caucasian%20female%20professional%20in%20casual%20business%20attire%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20high%20quality%20corporate%20portrait&width=200&height=200&seq=testimonial-006&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-zinc-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real reviews from satisfied customers who trust Seneca Tire Shop for their tire needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-zinc-900 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed">{testimonial.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
